export const definedTranslation = {
  card: {
    digitalCatalogLabel: {
      id: 'digital-catalog-label',
      defaultMessage: 'Digital Catalog',
    },
    learnMoreLabel: {
      id: 'learn-more-label',
      defaultMessage: 'Learn more',
    },
    seeSimilarLabel: {
      id: 'catalog-material-see-similar-label',
      defaultMessage: 'See Similar',
    },
    geoRestrictedTooltip: {
      id: 'catalog-material-geo-restricted-label',
      defaultMessage: 'Not available in your location.',
    },
    projectRestrictedTooltip: {
      id: 'catalog-material-project-restricted-label',
      defaultMessage: 'Not available for your project type.',
    },
    availabilityRestrictedTooltip: {
      id: 'catalog-material-availability-restricted-label',
      defaultMessage: 'This item is out of stock',
    },
    previewFilesLabel: {
      id: 'catalog-material-preview-files-label',
      defaultMessage: 'Preview Files',
    },
    addToCartLabel: {
      id: 'catalog-material-add-to-cart-button',
      defaultMessage: 'Add to Cart',
    },
    addedToCartLabel: {
      id: 'catalog-material-added-to-cart-button',
      defaultMessage: 'Added to Cart',
    },
    createProjectButtonLabel: {
      id: 'catalog-create-project-button',
      defaultMessage: 'Create Project',
    },
    inStockLabel: {
      id: 'catalog-material-in-stock-label',
      defaultMessage: 'Ships overnight',
    },
    outOfStockLabel: {
      id: 'catalog-material-out-of-stock-label',
      defaultMessage: '1–5+ Days From Brand',
    },
    projectPreLabel: {
      id: 'catalog-project-selector-label',
      defaultMessage: 'Project',
    },
    sampleFinishesLabel: {
      id: 'catalog-material-sample-finishes-button',
      defaultMessage: 'Sample Finishes',
    },
    newLabel: {
      id: 'catalog-material-new-label',
      defaultMessage: 'New',
    },
    justAddedLabel: {
      id: 'catalog-material-just-added-label',
      defaultMessage: 'Just Added',
    },
    colorwaysLabel: {
      id: 'catalog-material-colorways-label',
      defaultMessage: 'Colorways',
    },
    saveButtonLabel: {
      id: 'catalog-material-save-button',
      defaultMessage: 'Add to Board',
    },
    savedButtonLabel: {
      id: 'catalog-material-saved-button',
      defaultMessage: 'Added to Board',
    },
    savingButtonLabel: {
      id: 'catalog-material-saving-button',
      defaultMessage: 'Saving',
    },
    orderNow: {
      id: 'catalog-material-order-now-label',
      defaultMessage: 'Order Now',
    },
    finishes: {
      id: 'catalog-material-finishes-label',
      defaultMessage: 'Finishes',
    },
    listView: {
      shippingLabel: {
        id: 'catalog-material-list-view-shipping-label',
        defaultMessage: 'Shipping',
      },
      pricelabel: {
        id: 'catalog-material-list-view-price-label',
        defaultMessage: 'Price',
      },
      usageLabel: {
        id: 'catalog-material-list-view-usage-label',
        defaultMessage: 'Usage',
      },
      materialsLabel: {
        id: 'catalog-material-list-view-materials-label',
        defaultMessage: 'Materials',
      },
      sectorLabel: {
        id: 'catalog-material-list-view-sector-label',
        defaultMessage: 'Sector',
      },
    },
  },
  miniPDP: {
    detailsButtonLabel: {
      id: 'catalog-mini-pdp-learn-more-button',
      defaultMessage: 'Learn more',
    },
    infoBrandLabel: {
      id: 'catalog-mini-pdp-brand-label',
      defaultMessage: 'Brand',
    },
    infoUsageLabel: {
      id: 'catalog-mini-pdp-usage-label',
      defaultMessage: 'Usage',
    },
    infoSkuLabel: {
      id: 'catalog-mini-pdp-sku-label',
      defaultMessage: 'SKU',
    },
    tooltipData: {
      sku: {
        id: 'mini-pdp-tooltip-sku-label',
        defaultMessage: 'SKU',
      },
      price: {
        id: 'mini-pdp-tooltip-price-label',
        defaultMessage: 'Price Range',
      },
      content: {
        id: 'mini-pdp-tooltip-content-label',
        defaultMessage: 'Content',
      },
      flammability: {
        id: 'mini-pdp-tooltip-flammability-label',
        defaultMessage: 'Flammability',
      },
      size: {
        id: 'mini-pdp-tooltip-size-label',
        defaultMessage: 'Size',
      },
      indoorOutdoor: {
        id: 'mini-pdp-tooltip-indoor-outdoor-label',
        defaultMessage: 'Usage',
      },
      sectorLabel: {
        id: 'mini-pdp-tooltip-sector-label',
        defaultMessage: 'Sector',
      },
    },
  },
  quickView: {
    variationsLabel: {
      id: 'catalog-mini-pdp-variations-label',
      defaultMessage: 'Variations',
    },
    detailsButtonLabel: {
      id: 'catalog-mini-pdp-learn-more-button',
      defaultMessage: 'Learn more',
    },
    projectPreLabel: {
      id: 'catalog-project-selector-label',
      defaultMessage: 'Project',
    },
    addToCartButtonLabel: {
      id: 'catalog-material-add-to-cart-button',
      defaultMessage: 'Add to Cart',
    },
    createProjectButtonLabel: {
      id: 'catalog-create-project-button',
      defaultMessage: 'Create Project',
    },
    contactRepButtonLabel: {
      id: 'catalog-contact-rep-button',
      defaultMessage: 'Contact Rep',
    },
  },
  filters: {
    promoItemsLabel: {
      id: 'catalog-search-promo-items-label',
      defaultMessage: 'Reps Only',
    },
    searchFilters: {
      id: 'catalog-search-filters-placeholder',
      defaultMessage: 'Search filters',
    },
    clearAll: {
      id: 'catalog-clear-all-button',
      defaultMessage: 'Clear All',
    },
    allCategories: {
      id: 'catalog-all-categories-button',
      defaultMessage: 'All',
    },
    colorwaysToggle: {
      id: 'catalog-all-colorways-toggle',
      defaultMessage: 'All Colorways',
      description: 'All Colorways',
    },
    filtersButton: {
      id: 'catalog-filters-button',
      defaultMessage: 'Filters',
      description: 'Filters Button',
    },
    moreFiltersButton: {
      id: 'catalog-sidebar-more-filters-button',
      defaultMessage: 'More Filters',
      description: 'Catalog more filters button',
    },
    backButton: {
      id: 'catalog-filters-back-button',
      defaultMessage: 'Back',
    },
    searchPlaceholder: {
      id: 'catalog-filters-search-placeholder-text',
      defaultMessage: 'Search',
    },
    showLabel: {
      id: 'catalog-filters-mobile-show-label',
      defaultMessage: 'Show',
    },
    itemsLabel: {
      id: 'catalog-filters-mobile-items-label',
      defaultMessage: 'items',
    },
    searchCategoriesLabel: {
      id: 'catalog-filters-search-categories-label',
      defaultMessage: ' Search categories..',
    },
    digitalFilterTooltipSubtitle: {
      id: 'catalog-filters-digital-filter-tooltip-subtitle',
      defaultMessage:
        'Browse catalog sections that match your sample preferences.',
    },
  },
  launches: {
    curratedCollectionsTitle: {
      id: 'catalog-curated-collections-title',
      defaultMessage: 'Curated Collections',
      description: 'Curated Collections title',
    },
    exploreCollectionsButton: {
      id: 'catalog-explore-collections-button',
      defaultMessage: 'Explore Collections',
      description: ' Explore Collections title',
    },
  },
  infoNavbar: {
    productDetails: {
      id: 'catalog-action-menu-product-details-button',
      defaultMessage: 'Product Details',
      description: 'Product Details',
    },
    listView: {
      id: 'catalog-action-menu-list-view-button',
      defaultMessage: 'List View',
      description: 'List View',
    },
    largeThumbnails: {
      id: 'catalog-action-menu-large-thumbnails-button',
      defaultMessage: 'Large Thumbnails',
      description: 'Large Thumbnails',
    },
    addAllToCart: {
      id: 'catalog-action-menu-add-all-button',
      defaultMessage: 'Add All to Cart',
    },
  },
  noResults: {
    title: {
      id: 'catalog-no-results-page-title',
      defaultMessage: "Sorry, we don't have this product",
    },
    subtitle: {
      id: 'catalog-no-results-page-subtitle',
      defaultMessage:
        'See similar materials or connect with a brand rep for more options.',
    },
  },
  selectMenu: {
    selectAll: {
      id: 'catalog-topbar-select-menu-select-all-label',
      defaultMessage: 'Select All',
    },
    cancel: {
      id: 'catalog-topbar-select-menu-cancel-label',
      defaultMessage: 'Cancel',
    },
    onlySamples: {
      id: 'catalog-topbar-select-menu-only-samples-label',
      defaultMessage: 'Only Samples',
    },
    itemsSelected: {
      id: 'catalog-topbar-select-menu-items-selected-label',
      defaultMessage: 'items selected',
    },
    save: {
      id: 'catalog-topbar-select-menu-save-button',
      defaultMessage: 'Add to Board',
    },
    addToCart: {
      id: 'catalog-topbar-select-menu-add-to-cart-button',
      defaultMessage: 'Add to Cart',
    },
    cartRestriction: {
      id: 'catalog-topbar-select-menu-cart-restriction-error',
      defaultMessage:
        'You have selected an item that cannot be added to your cart',
    },
    remove: {
      id: 'catalog-topbar-select-menu-add-to-cart-button',
      defaultMessage: 'Add to Cart',
    },
    shareExport: {
      id: 'catalog-topbar-select-menu-share-export-label',
      defaultMessage: 'Share/Export',
    },
    openInDesk: {
      id: 'catalog-topbar-select-menu-open-desk-label',
      defaultMessage: 'Open in Desk',
    },
    selectAllTooltip: {
      id: 'catalog-topbar-select-select-all-tooltip',
      defaultMessage:
        'Please narrow your search to be able to select all the items.',
    },
    addToBagTooltip: {
      id: 'catalog-topbar-select-add-to-bag-tooltip',
      defaultMessage: 'Not available for products',
    },
  },
  recommendStrip: {
    title: {
      id: 'recommendStrip-block-title',
      defaultMessage: 'Recommended for you',
    },
  },
  collections: {
    titleDefault: {
      id: 'collections-block-title',
      defaultMessage: 'Discover something new',
    },
    titleSearched: {
      id: 'collections-block-title',
      defaultMessage: 'Recommendations based on your search',
    },
    button: {
      id: 'collections-block-all-button',
      defaultMessage: 'See All',
    },
    materialText: {
      id: 'collections-material-text',
      defaultMessage: 'material',
    },
    materialsText: {
      id: 'collections-materials-text',
      defaultMessage: 'materials',
    },
  },
  downloadModal: {
    title: {
      id: 'catalog-download-modal-title',
      defaultMessage: 'Download',
    },
    selectedLabel: {
      id: 'catalog-download-modal-selected-label',
      defaultMessage: 'Selected',
    },
    infoButton: {
      id: 'catalog-download-modal-info-button',
      defaultMessage: 'Material Information',
    },
    docsButton: {
      id: 'catalog-download-modal-docs-button',
      defaultMessage: 'Material Documents',
    },
  },
  projectMessages: {
    projectUpdated: {
      id: 'catalog-project-updated-message',
      defaultMessage: 'Current project successfully updated',
    },
    errorProjectSet: {
      id: 'catalog-error-project-set',
      defaultMessage: 'Cannot set current project',
    },
  },
  compare: {
    header: {
      id: 'catalog-compare-feature-header',
      defaultMessage: 'Select up to five items',
    },
    toggleLabel: {
      id: 'catalog-compare-feature-toggle-label',
      defaultMessage: 'Compare',
    },
    startCompareButtonLabel: {
      id: 'catalog-compare-feature-start-compare-button-label',
      defaultMessage: 'Compare',
    },
    cancelCompareButtonLabel: {
      id: 'catalog-compare-feature-start-cancel-button-label',
      defaultMessage: 'Cancel',
    },
    disabledButtonTooltip: {
      id: 'catalog-compare-feature-disabled-button-tooltip',
      defaultMessage: 'You need to add at least 2 items to start comparing',
    },
    compareLimitReachedlabel: {
      id: 'catalog-compare-feature-limit-label',
      defaultMessage: 'You can add up to five items for comparison',
    },
  },
  comparePage: {
    title: {
      id: 'catalog-compare-page-title',
      defaultMessage: 'Compare Products',
    },
    shareButton: {
      id: 'catalog-compare-page-share-button',
      defaultMessage: 'Share',
    },
    exportButton: {
      id: 'catalog-compare-page-export-button',
      defaultMessage: 'Export',
    },
    seeDifferenceLabel: {
      id: 'catalog-compare-page-see-difference-label',
      defaultMessage: 'See differences only',
    },
    removeButton: {
      id: 'catalog-compare-page-remove-button',
      defaultMessage: 'Remove',
    },
    shareModalTitle: {
      id: 'catalog-compare-share-modal-title',
      defaultMessage: 'Share comparison',
    },
    shareModalButton: {
      id: 'catalog-compare-share-modal-button',
      defaultMessage: 'Copy shareable link',
    },
    shareModalButtonError: {
      id: 'catalog-compare-share-modal-button-error',
      defaultMessage: 'Failed to copy!',
    },
    shareModalButtonSuccess: {
      id: 'catalog-compare-share-modal-button-success',
      defaultMessage: 'Link copied!',
    },
  },
  loadingLabel: {
    id: 'catalog-loading-label',
    defaultMessage: 'Loading',
  },
  topBanners: {
    backButton: {
      id: 'catalog-top-banners-back-button',
      defaultMessage: 'Back',
    },
  },
};
